var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cp-about" }, [
    _vm._m(0),
    _c("div", { staticClass: "w", attrs: { id: "company-profile" } }, [
      _c("h2", [_vm._v("公司简介")]),
      _c("h3", [_vm._v("Company profile")]),
      _c("h4", [_vm._v("智能服务机器人研发及产业化领先企业")]),
      _c("p", [
        _vm._v(
          "弗徕威智能机器人科技（上海）有限公司是国内率先参与制订服务机器人企业标准、并获得首批认证的企业。2012年8月注册于上海浦东，是国家高新技术企业、科技部创新基金支持单位、国家战略新兴产业标准化试点单位、科技部《养老服务课题》承接单位、国家知识产权局“专利试点单位”、上海市“专精特新”企业、浦东新区科委重点科技创业企业以及国家三部委（工信部、民政部、卫健委）授予智慧健康养老应用试点示范企业。作为主要参编单位、企业参与了4个机器人国家标准和4个行业标准制定。"
        )
      ]),
      _c("p", [
        _vm._v(
          "企业专注于服务机器人领域深耕十年，是全球领先的以智能机器人为核心技术的智慧社区解决方案供应商，拥有完整自主知识产权体系且可自主生产服务机器人。企业是国内最早实现机器人量产、且一次性交付量最大的服务机器人之一，技术实现力和产品稳定性已获市场验证。团队核心成员主要来自机器人领域具有国际和国内影响力的专家，已授权核心发明专利数量行业领先。企业已形成机器人智慧社区、智慧康养、智能清洁等多场景解决方案，且在多个地产项目和康养机构示范应用落地。科技赋能，共创美好生活。"
        )
      ]),
      _vm.isMobile
        ? _c("img", {
            staticClass: "img",
            attrs: { src: require("../assets/mobile/about-citys.jpg") }
          })
        : _c("img", {
            staticClass: "img",
            attrs: { src: require("../assets/web/about-citys.jpg") }
          })
    ]),
    _vm._m(1),
    _vm._m(2)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner" }, [
      _c("p", { staticClass: "p1" }, [_vm._v("关爱触手可及")]),
      _c("p", { staticClass: "p2" }, [_vm._v("CARE YOU CAN TOUCH")]),
      _c("p", { staticClass: "p3" }, [
        _vm._v("让机器人进入千家万户，成为服务机器人行业的领先企业")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "w", attrs: { id: "application-area" } }, [
      _c("h2", [_vm._v("应用领域")]),
      _c("h3", [_vm._v("Application Area")]),
      _c("ul", { staticClass: "list" }, [
        _c("li", [
          _c("img", {
            attrs: { src: require("../assets/web/about-img1.png") }
          }),
          _c("div", { staticClass: "title" }, [_vm._v("智慧社区")]),
          _c("p", [
            _vm._v(" 提供以机器人为核心的"),
            _c("br"),
            _vm._v("整套智慧住宅解决方案")
          ])
        ]),
        _c("li", [
          _c("img", {
            attrs: { src: require("../assets/web/about-img2.png") }
          }),
          _c("div", { staticClass: "title" }, [_vm._v("智慧康养")]),
          _c("p", [
            _vm._v("提供专业的长者居家照护和陪伴服务机器人"),
            _c("br"),
            _vm._v("打造机器人智慧康养社区")
          ])
        ]),
        _c("li", [
          _c("img", {
            attrs: { src: require("../assets/web/about-img3.png") }
          }),
          _c("div", { staticClass: "title" }, [_vm._v("智慧清洁")]),
          _c("p", [
            _vm._v("提供公共空间无人驾驶智能清洁、"),
            _c("br"),
            _vm._v("消杀毒服务机器人解决方案")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "contact-us" } }, [
      _c("div", { staticClass: "w" }, [
        _c("h2", [_vm._v("联系我们")]),
        _c("h3", [_vm._v("Contact us")]),
        _c("div", { staticClass: "info1" }, [
          _c("div", { staticClass: "left" }, [
            _c("h4", [_vm._v("联系方式")]),
            _c("p", [_vm._v("地址：上海·长宁·威宁路369号缤谷大厦10楼1001室")]),
            _c("p", [_vm._v("地址：上海·浦东·芳春路400号1幢3层")]),
            _c("p", [_vm._v("总机：193 0215 5869")]),
            _c("p", [_vm._v("邮箱：marketing@flyingwings.cn")])
          ])
        ]),
        _c("div", { staticClass: "info2" }, [
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("业务合作")]),
            _c("p", [_vm._v("电话：193 0215 5869")])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("供应商合作")]),
            _c("p", [_vm._v("电话：193 0215 5869")])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("售后服务")]),
            _c("p", [_vm._v("电话：193 0215 5869")])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("媒体合作")]),
            _c("p", [
              _vm._v("邮箱："),
              _c("a", { attrs: { href: "mailto:jj.li@flyingwings.cn" } }, [
                _vm._v("marketing@flyingwings.cn")
              ])
            ])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("产品反馈")]),
            _c("p", [
              _vm._v("邮箱："),
              _c("a", { attrs: { href: "mailto:feedback@flyingwing.cn" } }, [
                _vm._v("feedback@flyingwing.cn")
              ])
            ])
          ]),
          _c("div", { staticClass: "item" }, [
            _c("h4", [_vm._v("加入我们")]),
            _c("p", [
              _vm._v("邮箱："),
              _c("a", { attrs: { href: "mailto:hr@flyingwings.cn" } }, [
                _vm._v("hr@flyingwings.cn")
              ])
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23b71e09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b71e09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/about.vue
// module id = Z3A+
// module chunks = 0